interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/**
 * Figma "Blocks" nav-tab icon — resting (filled) state, exported asset
 * (block-nav-2.svg): five rounded squares with a real gap between each,
 * shown as `color` fill on a white stroke. Pairs with `FigmaBlocksOutlineIcon`
 * (the active state, same shape with fill/stroke swapped).
 */
const FigmaBlocksFilledIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 120 120'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_76709_11945)'>
        <path
          d='M40.4219 3.46191C44.3011 3.46201 48.012 4.98329 50.7412 7.67676C53.469 10.369 54.9932 14.0105 54.9932 17.7979V39.4834H18.4609V3.46191H40.4219Z'
          fill={color}
          stroke='white'
          strokeWidth='6.92308'
        />
        <path
          d='M54.9919 42.0194V77.9833H18.4597V42.0194H54.9919Z'
          fill={color}
          stroke='white'
          strokeWidth='6.92308'
        />
        <path
          d='M75.553 42.0194C77.988 42.0194 80.3984 42.4924 82.6458 43.411C84.7526 44.2723 86.6767 45.5084 88.3225 47.0546L88.6477 47.368C90.3629 49.0608 91.721 51.0685 92.6467 53.2743C93.5723 55.4797 94.0481 57.842 94.0481 60.2264V77.9833H57.5159V42.0194H75.553Z'
          fill={color}
          stroke='white'
          strokeWidth='6.92308'
        />
        <path
          d='M54.9919 80.575V116.539H37.1355C34.6772 116.54 32.2434 116.063 29.9744 115.136C27.8469 114.268 25.9036 113.02 24.2419 111.46L23.9138 111.143L23.5935 110.819C22.0121 109.18 20.7514 107.269 19.8748 105.181C18.9398 102.955 18.4597 100.568 18.4597 98.1609V80.575H54.9919Z'
          fill={color}
          stroke='white'
          strokeWidth='6.92308'
        />
        <path
          d='M94.0481 80.575V98.7214C94.048 103.432 92.1522 107.958 88.7629 111.303C85.3721 114.65 80.7634 116.539 75.9485 116.539H57.5159V80.575H94.0481Z'
          fill={color}
          stroke='white'
          strokeWidth='6.92308'
        />
      </g>
      <defs>
        <clipPath id='clip0_76709_11945'>
          <rect width='120' height='120' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FigmaBlocksFilledIcon;
